/**
 * Configuracao da URL da API para o Clube Beneficios
 * Le a configuracao do window.__ENV__ (definido em public/env-config.js)
 */

// Le a URL do ambiente configurado no public/env-config.js
export const BASE_URL =
  (window as any).__ENV__?.REACT_APP_OG_API_URL ||
  'https://api.odontogroup.com.br';
